export default __webpack_public_path__ + "static/media/price-change-bg.05fc4884.svg";